module.exports = __webpack_public_path__ + "static/map_usa_SO_mobile-fb74f3299ec7ea45a983223ffd496672.png";